"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "san-cipriano-d-aversa": {
    "ef59e074": [{
      "hkey": "bbab9966",
      "slug": "san-cipriano-d-aversa",
      "name": "San Cipriano d'Aversa",
      "primary": true,
      "skipSearch": false
    }],
    "calitto": [{
      "hkey": "bbab9966",
      "slug": "san-cipriano-d-aversa",
      "name": "San Cipriano d'Aversa",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a53d48c3": [{
      "hkey": "bbab9966",
      "slug": "san-cipriano-d-aversa",
      "name": "San Cipriano d'Aversa",
      "primary": true,
      "skipSearch": false
    }],
    "cancello": [{
      "hkey": "bbab9966",
      "slug": "san-cipriano-d-aversa",
      "name": "San Cipriano d'Aversa",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c85460d6": [{
      "hkey": "bbab9966",
      "slug": "san-cipriano-d-aversa",
      "name": "San Cipriano d'Aversa",
      "primary": true,
      "skipSearch": false
    }],
    "casino-beneventano": [{
      "hkey": "bbab9966",
      "slug": "san-cipriano-d-aversa",
      "name": "San Cipriano d'Aversa",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "9ef213ff": [{
      "hkey": "bbab9966",
      "slug": "san-cipriano-d-aversa",
      "name": "San Cipriano d'Aversa",
      "primary": true,
      "skipSearch": false
    }],
    "castegno": [{
      "hkey": "bbab9966",
      "slug": "san-cipriano-d-aversa",
      "name": "San Cipriano d'Aversa",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "10475068": [{
      "hkey": "bbab9966",
      "slug": "san-cipriano-d-aversa",
      "name": "San Cipriano d'Aversa",
      "primary": true,
      "skipSearch": false
    }],
    "grammigliuolo": [{
      "hkey": "bbab9966",
      "slug": "san-cipriano-d-aversa",
      "name": "San Cipriano d'Aversa",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "2b11cef8": [{
      "hkey": "bbab9966",
      "slug": "san-cipriano-d-aversa",
      "name": "San Cipriano d'Aversa",
      "primary": true,
      "skipSearch": false
    }],
    "incoronata": [{
      "hkey": "bbab9966",
      "slug": "san-cipriano-d-aversa",
      "name": "San Cipriano d'Aversa",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "0b8bf48f": [{
      "hkey": "bbab9966",
      "slug": "san-cipriano-d-aversa",
      "name": "San Cipriano d'Aversa",
      "primary": true,
      "skipSearch": false
    }],
    "isola": [{
      "hkey": "bbab9966",
      "slug": "san-cipriano-d-aversa",
      "name": "San Cipriano d'Aversa",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "92a1796b": [{
      "hkey": "bbab9966",
      "slug": "san-cipriano-d-aversa",
      "name": "San Cipriano d'Aversa",
      "primary": true,
      "skipSearch": false
    }],
    "madonna-del-carmine": [{
      "hkey": "bbab9966",
      "slug": "san-cipriano-d-aversa",
      "name": "San Cipriano d'Aversa",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f09d61eb": [{
      "hkey": "bbab9966",
      "slug": "san-cipriano-d-aversa",
      "name": "San Cipriano d'Aversa",
      "primary": true,
      "skipSearch": false
    }],
    "maesone": [{
      "hkey": "bbab9966",
      "slug": "san-cipriano-d-aversa",
      "name": "San Cipriano d'Aversa",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f7ffa93b": [{
      "hkey": "bbab9966",
      "slug": "san-cipriano-d-aversa",
      "name": "San Cipriano d'Aversa",
      "primary": true,
      "skipSearch": false
    }],
    "perillo": [{
      "hkey": "bbab9966",
      "slug": "san-cipriano-d-aversa",
      "name": "San Cipriano d'Aversa",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;